import { createContext } from "react";

export const ModalContext = createContext<ModalContext>({
  open: null,
  setOpen: null,
  setProcessingModal: null,
});
